import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { PessoaJuridica } from "../shared/pessoa-juridica.model";
import { CnpjValidator } from "../../../shared/validators/cnpj.validation";
import { EmailValidator } from "../../../shared/validators/email.validation";
import { PhoneValidator } from "../../../shared/validators/phone.validation";

@Component({
  selector: 'app-pessoa-juridica-form',
  template: require('./pessoa-juridica-form.component.html'),
  styles: [require('./pessoa-juridica-form.component.css')]
})
export class PessoaJuridicaFormComponent implements OnInit {
  @Input() formObject: any = new PessoaJuridica();
  @Input() submitted: boolean = false;

  form: FormGroup;
  cnpj = new FormControl('', Validators.compose([Validators.required, CnpjValidator.cnpjFormat]));
  email = new FormControl('', Validators.compose([EmailValidator.emailFormat]));
  razaoSocial = new FormControl('', Validators.required);
  nomeFantasia = new FormControl();
  telefone = new FormControl('', Validators.compose([PhoneValidator.phoneFormat]));
  ativo = new FormControl('');

  constructor(
    private _fb: FormBuilder
  ) {
    this.form = _fb.group({
      ativo: this.ativo,
      email: this.email,
      cnpj: this.cnpj,
      razaoSocial: this.razaoSocial,
      telefone: this.telefone,
      nomeFantasia: this.nomeFantasia
    });
  }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoa-juridica/pessoa-juridica-form/pessoa-juridica-form.component.ts
 **/